var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.939,
    height: 15.859,
    viewBox: "0 0 13.939 15.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.08,12.264a2.037,2.037,0,0,0-.6-1.45,1.115,1.115,0,0,1-.328-.793V6.5a3.721,3.721,0,0,1-3.717-3.717,3.679,3.679,0,0,1,.347-1.547A5.159,5.159,0,0,0,37.5.972V0h-.929V.953A5.116,5.116,0,0,0,31.929,6.04v3.98a1.114,1.114,0,0,1-.328.793,2.037,2.037,0,0,0-.6,1.45V13H43.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pulse",
    fill: "#1c97ce",
    d: "M303.788,5.576A2.788,2.788,0,1,0,301,2.788,2.788,2.788,0,0,0,303.788,5.576Z",
    transform: "translate(-261.637)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M168.23,483.477A2.218,2.218,0,0,0,170.076,482h-3.693A2.218,2.218,0,0,0,168.23,483.477Z",
    transform: "translate(-131.189 -467.618)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/bell-active.9b6465a3c9637eea609543eb2cebf977.svg";
export { ForwardRef as ReactComponent };